import React from 'react';
import { Row, Col, Button } from 'antd';

import { PlusCircleOutlined } from '@ant-design/icons';

import { useTranslation } from 'react-i18next';

const PageHeader = ({ onAdd, title, buttonText, showButton }) => {
  return (
    <Row
      gutter={[16]}
      style={{
        margin: '0 0 10px 0',
        padding: '10px 0',
        alignItems: 'center',
      }}
      justify="space-between"
    >
      <Col>
        <h2>{title}</h2>
      </Col>
      {showButton && (
        <Col>
          <Button
            type="primary"
            shape="round"
            icon={<PlusCircleOutlined />}
            onClick={() => {
              onAdd();
            }}
          >
            {buttonText}
          </Button>
        </Col>
      )}
    </Row>
  );
};

export default PageHeader;
